export default "__VITE_ASSET__VBNT0jdT__"